import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const CountdownStopTimer = (props: { stop: () => void; ms: number }) => {
  const [second, setSecond] = useState(props.ms / 1000);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (second > 0) {
        setSecond(second - 1);
      } else {
        props.stop();
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [props, second]);
  return (
    <Stack
      mt={2}
      sx={{ maxHeight: '65%', minHeight: '35%' }}
      justifyContent={'space-evenly'}
      alignContent={'center'}
      alignItems={'center'}
      width={'100%'}
    >
      <Typography variant="h5" textAlign={'center'}>{`00:${('0' + second).slice(
        -2
      )}`}</Typography>
      <Box
        onClick={props.stop}
        sx={{
          height: '80%',
          maxHeight: 100,
          aspectRatio: 1 / 1,
          position: 'relative',
          borderRadius: '50%',
          cursor: 'pointer',
        }}
        my={1}
        mx={'auto'}
      >
        <CircularProgress
          value={second * (100 / (props.ms / 1000))}
          variant="determinate"
          size={'100%'}
          sx={{
            scale: '-1 1',
            color: '#173c6a',
            bgcolor: '#e9f4fbff',
            borderRadius: '50%',
            position: 'absolute',
            maxHeight: '100%',
          }}
        />
        <SquareRoundedIcon
          sx={{
            position: 'absolute',
            color: '#173c6a',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: 'auto',
          }}
        />
      </Box>
    </Stack>
  );
};
export default CountdownStopTimer;
